<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/transaction/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Transaction
      List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    Create Offline Transaction
  </div>
  <div class="page-content shadow p-3 position-relative">
    <form class="mat-form" [formGroup]="createTxnFrom">
      <div class="row mt-2">
        <div class="col-md-6 form-group">
          <app-input-select
            (selectionChange)="onSourceCountryChange($event); onKeyUp('')"
            [inputData]="attrConstant.sourceCountry"
            [selectOptions]="sourceCountryList | async"
            [bindLabel]="'countryName'"
            [bindValue]="'countryCode'"
            [formControlName]="
              attrConstant.sourceCountry.key
            "></app-input-select>
        </div>
        <div class="col-md-6 form-group">
          <app-input-select
            (selectionChange)="onDestCountryChange($event); onKeyUp('')"
            [inputData]="attrConstant.destCountry"
            [selectOptions]="destCountryList | async"
            [bindLabel]="'countryName'"
            [bindValue]="'countryCode'"
            [formControlName]="attrConstant.destCountry.key"></app-input-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group">
          <app-input-select
            (selectionChange)="onKeyUp('')"
            [inputData]="attrConstant.transferType"
            [selectOptions]="transactionSettings?.transfer_types ?? []"
            [bindLabel]="'name'"
            [bindValue]="'value'"
            [formControlName]="
              attrConstant.transferType.key
            "></app-input-select>
        </div>
        <div class="col-md-6 form-group">
          <app-input-select
            (selectionChange)="onKeyUp('')"
            [inputData]="attrConstant.serviceLevel"
            [selectOptions]="
              transactionSettings?.service_level_delivery_speed_codes ?? []
            "
            [bindLabel]="'name'"
            [bindValue]="'code'"
            [formControlName]="
              attrConstant.serviceLevel.key
            "></app-input-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group">
          <app-input-select
            [inputData]="attrConstant.sourceOfIncome"
            [selectOptions]="transactionSettings?.source_of_income_codes ?? []"
            [bindLabel]="'name'"
            [bindValue]="'name'"
            [formControlName]="
              attrConstant.sourceOfIncome.key
            "></app-input-select>
        </div>
        <div class="col-md-6 form-group">
          <app-input-select
            [inputData]="attrConstant.purpose"
            [selectOptions]="
              transactionSettings?.remittance_purpose_codes ?? []
            "
            [bindLabel]="'name'"
            [bindValue]="'name'"
            [formControlName]="attrConstant.purpose.key"></app-input-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group">
          <app-input-select
            (selectionChange)="onKeyUp('')"
            [inputData]="attrConstant.paymentType"
            [selectOptions]="transactionSettings?.payment_method_codes ?? []"
            [bindLabel]="'name'"
            [bindValue]="'imgPath'"
            [formControlName]="attrConstant.paymentType.key"></app-input-select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <mat-card formGroupName="senderDetails">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <mat-card-title class="mb-0">Sender Details</mat-card-title>
              <div class="d-flex align-items-center gap-20">
                <a
                  class="btn primary-btn"
                  [attr.aria-hidden]="true"
                  (click)="onChooseClick(true)">
                  Choose Sender
                </a>
                <div *ngIf="isExistingSender">
                  <img
                    src="assets/images/clear-filter.svg"
                    class="clear-img"
                    alt="clear-filter"
                    matTooltip="Clear Selection"
                    matTooltipPosition="above"
                    [attr.aria-hidden]="true"
                    (click)="clearSelection(true)" />
                </div>
              </div>
            </div>
            <mat-divider class="position-relative mb-3"></mat-divider>
            <div class="row">
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.firstName"
                  [formControlName]="
                    attrConstant.firstName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.middleName"
                  [formControlName]="
                    attrConstant.middleName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.lastName"
                  [formControlName]="
                    attrConstant.lastName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.address1"
                  [formControlName]="
                    attrConstant.address1.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.city"
                  [formControlName]="
                    attrConstant.city.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.country"
                  [formControlName]="
                    attrConstant.country.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.postalCode"
                  [formControlName]="
                    attrConstant.postalCode.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.email"
                  [formControlName]="
                    attrConstant.email.key
                  "></app-input-template>
              </div>
              <div class="col-md-2 col-3 form-group pe-0">
                <app-input-template
                  [inputData]="attrConstant.mobileCode"
                  [formControlName]="
                    attrConstant.mobileCode.key
                  "></app-input-template>
              </div>
              <div class="col-md-10 col-9 form-group">
                <app-input-template
                  [inputData]="attrConstant.mobileNumber"
                  [formControlName]="
                    attrConstant.mobileNumber.key
                  "></app-input-template>
              </div>
              <!-- New-sender (inline) fields; hidden when an existing sender is chosen. -->
              <ng-container *ngIf="!isExistingSender">
                <div class="col-12 form-group">
                  <app-input-select
                    [inputData]="attrConstant.gender"
                    [selectOptions]="gender"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.gender.key
                    "></app-input-select>
                </div>
                <div class="col-12 form-group">
                  <app-input-datepicker
                    [inputData]="attrConstant.dob"
                    [formControlName]="
                      attrConstant.dob.key
                    "></app-input-datepicker>
                </div>
                <div class="col-12 form-group">
                  <app-input-template
                    (passwordChanged)="patchPassword($event)"
                    [inputData]="attrConstant.password"
                    [formControlName]="
                      attrConstant.password.key
                    "></app-input-template>
                </div>
                <div class="col-12 form-group">
                  <app-input-template
                    [inputData]="attrConstant.pin"
                    [formControlName]="
                      attrConstant.pin.key
                    "></app-input-template>
                </div>
                <div class="col-12 form-group">
                  <app-input-template
                    [inputData]="attrConstant.address2"
                    [formControlName]="
                      attrConstant.address2.key
                    "></app-input-template>
                </div>
                <div class="col-12 form-group">
                  <app-input-template
                    [inputData]="attrConstant.town"
                    [formControlName]="
                      attrConstant.town.key
                    "></app-input-template>
                </div>
                <div class="col-12">
                  <mat-card-subtitle>Identity Document</mat-card-subtitle>
                </div>
                <div class="col-12 form-group">
                  <app-input-select
                    [inputData]="attrConstant.docType"
                    [selectOptions]="documentType"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.docType.key
                    "></app-input-select>
                </div>
                <div class="col-12 form-group">
                  <app-input-select
                    [inputData]="attrConstant.docSection"
                    [selectOptions]="documentSection"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.docSection.key
                    "></app-input-select>
                </div>
                <div class="col-12 form-group">
                  <app-input-template
                    [inputData]="attrConstant.docNumber"
                    [formControlName]="
                      attrConstant.docNumber.key
                    "></app-input-template>
                </div>
                <div class="col-12 form-group">
                  <app-input-datepicker
                    [inputData]="attrConstant.docExpiryDate"
                    [formControlName]="
                      attrConstant.docExpiryDate.key
                    "></app-input-datepicker>
                </div>
                <div class="col-12 form-group">
                  <app-input-file
                    (chooseDocument)="onChooseDocument($event)"
                    [inputData]="attrConstant.image"
                    [formControlName]="
                      attrConstant.image.key
                    "></app-input-file>
                </div>
              </ng-container>
            </div>
          </mat-card>
        </div>
        <div class="col-md-6">
          <mat-card formGroupName="beneDetails">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <mat-card-title class="mb-0">Beneficiary Details</mat-card-title>
              <div class="d-flex align-items-center gap-20">
                <a
                  class="btn primary-btn"
                  [attr.aria-hidden]="true"
                  (click)="onChooseClick(false)">
                  Choose Beneficiary
                </a>
                <div *ngIf="isExistingBeneficiary">
                  <img
                    src="assets/images/clear-filter.svg"
                    class="clear-img"
                    alt="clear-filter"
                    matTooltip="Clear Selection"
                    matTooltipPosition="above"
                    [attr.aria-hidden]="true"
                    (click)="clearSelection(false)" />
                </div>
              </div>
            </div>
            <mat-divider class="position-relative mb-3"></mat-divider>
            <div class="row">
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneFirstName"
                  [formControlName]="
                    attrConstant.beneFirstName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneMiddleName"
                  [formControlName]="
                    attrConstant.beneMiddleName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneLastName"
                  [formControlName]="
                    attrConstant.beneLastName.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneAddress"
                  [formControlName]="
                    attrConstant.beneAddress.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneCity"
                  [formControlName]="
                    attrConstant.beneCity.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneCountry"
                  [formControlName]="
                    attrConstant.beneCountry.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.benePostCode"
                  [formControlName]="
                    attrConstant.benePostCode.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneEmail"
                  [formControlName]="
                    attrConstant.beneEmail.key
                  "></app-input-template>
              </div>
              <div class="col-md-2 col-3 form-group pe-0">
                <app-input-template
                  [inputData]="attrConstant.beneMobileCode"
                  [formControlName]="
                    attrConstant.beneMobileCode.key
                  "></app-input-template>
              </div>
              <div class="col-md-10 col-9 form-group">
                <app-input-template
                  [inputData]="attrConstant.beneMobileNumber"
                  [formControlName]="
                    attrConstant.beneMobileNumber.key
                  "></app-input-template>
              </div>
              <app-transfer-details
                *ngIf="!isExistingBeneficiary"
                [group]="beneDetailsGroup"
                [showTransferTypeSelect]="false"
                [transferType]="
                  createTxnFrom.get(attrConstant.transferType.key)?.value
                "
                [destinationCountry]="
                  createTxnFrom.get(attrConstant.destCountry.key)?.value
                "></app-transfer-details>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <mat-card>
            <mat-card-title>Amount Details</mat-card-title>
            <mat-divider class="position-relative mb-3"></mat-divider>
            <div class="row">
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.sourceCurrency"
                  [formControlName]="
                    attrConstant.sourceCurrency.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  (inputChange)="onKeyUp('source')"
                  [inputData]="attrConstant.sourceAmount"
                  [formControlName]="
                    attrConstant.sourceAmount.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.destCurrency"
                  [formControlName]="
                    attrConstant.destCurrency.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  (inputChange)="onKeyUp('destination')"
                  [inputData]="attrConstant.destAmount"
                  [formControlName]="
                    attrConstant.destAmount.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.headOfficeFee"
                  [formControlName]="
                    attrConstant.headOfficeFee.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.commission"
                  [formControlName]="
                    attrConstant.commission.key
                  "></app-input-template>
              </div>
              <div class="col-12 form-group">
                <app-input-template
                  [inputData]="attrConstant.rate"
                  [formControlName]="
                    attrConstant.rate.key
                  "></app-input-template>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <button
        class="btn primary-btn w-100 mt-3"
        (click)="onCreateTransaction()">
        Submit
      </button>
    </form>
  </div>
</div>
